import React, { ImgHTMLAttributes, useState } from 'react';
import imgPlaceholderSrc from '../../images/img-placeholder.svg';

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
    useLocalBaseUrl?: boolean;
    imgPlaceholder?: string;
}

const Image = (props: ImageProps) => {
    const {
        src,
        useLocalBaseUrl = true,
        imgPlaceholder = imgPlaceholderSrc,
        style,
        ...restProps
    } = props;

    const baseUrl = useLocalBaseUrl ? process.env.REACT_APP_IMAGE_BASE_URL : '';
    const [imgSrc, setImgSrc] = useState<string | undefined>(
        `${baseUrl}${src}`
    );
    const [isLoaded, setIsLoaded] = useState(false);

    const handleError = () => {
        setImgSrc(imgPlaceholder);
        setIsLoaded(true);
    };

    const handleLoad = () => {
        setIsLoaded(true);
    };

    return (
        <>
            {!isLoaded && (
                <img
                    src={imgPlaceholder}
                    alt='placeholder'
                    style={{ display: 'block', ...style }}
                    {...restProps}
                />
            )}
            <img
                src={imgSrc}
                onLoad={handleLoad}
                onError={handleError}
                style={{
                    display: isLoaded ? 'unset' : 'none',
                    position: isLoaded ? 'unset' : 'absolute',
                    ...style,
                }}
                {...restProps}
            />
        </>
    );
};

export default Image;
